module.exports = __webpack_public_path__ + "img/Under-construct-01.3475c547.png";